import { render, staticRenderFns } from "./TabNews.vue?vue&type=template&id=01598db4&scoped=true&"
import script from "./TabNews.vue?vue&type=script&lang=js&"
export * from "./TabNews.vue?vue&type=script&lang=js&"
import style0 from "./TabNews.vue?vue&type=style&index=0&id=01598db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01598db4",
  null
  
)

export default component.exports